/**
 * 10Duke Session API
 * Authenticate user and manage authenticated sessions
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ActivateTotpConfigurationRequest } from '../model/activateTotpConfigurationRequest';
import { ApiError } from '../model/apiError';
import { DeactivateTotpConfigurationRequest } from '../model/deactivateTotpConfigurationRequest';
import { TotpConfiguration } from '../model/totpConfiguration';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TotpService {

    protected basePath = 'http://localhost:8080/api/0.exp';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Activates the current time-based one-time password (TOTP) configuration
     * Activates existing time-based one-time password (TOTP) configuration of the authenticated user by verifying two passcodes
     * @param body Specifies passcodes required for activating the TOTP configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateTotpConfiguration(body: ActivateTotpConfigurationRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public activateTotpConfiguration(body: ActivateTotpConfigurationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public activateTotpConfiguration(body: ActivateTotpConfigurationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public activateTotpConfiguration(body: ActivateTotpConfigurationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling activateTotpConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/totpConfiguration/activation`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a new time-based one-time password (TOTP) configuration
     * Creates time-based one-time password (TOTP) configuration for authenticated user who does not have an existing TOTP configuration. After creating the configuration, user must configure her MFA / TOTP device and activate this configuration by supplying codes generated by the configured device.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTotpConfiguration(observe?: 'body', reportProgress?: boolean): Observable<TotpConfiguration>;
    public createTotpConfiguration(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TotpConfiguration>>;
    public createTotpConfiguration(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TotpConfiguration>>;
    public createTotpConfiguration(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<TotpConfiguration>(`${this.basePath}/totpConfiguration`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deactivates the current time-based one-time password (TOTP) configuration
     * Deactivates existing time-based one-time password (TOTP) configuration of the authenticated user. This requires giving the current passcode.
     * @param body Specifies passcode required for deactivating the TOTP configuration
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deactivateTotpConfiguration(body: DeactivateTotpConfigurationRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deactivateTotpConfiguration(body: DeactivateTotpConfigurationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deactivateTotpConfiguration(body: DeactivateTotpConfigurationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deactivateTotpConfiguration(body: DeactivateTotpConfigurationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deactivateTotpConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/totpConfiguration/deactivation`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes time-based one-time password (TOTP) configuration
     * Deletes existing time-based one-time password configuration of the authenticated user. Currently active TOTP configuration can not be deleted, but it must be deactivated first.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTotpConfiguration(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTotpConfiguration(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTotpConfiguration(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTotpConfiguration(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/totpConfiguration`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets time-based one-time password (TOTP) configuration
     * Gets existing time-based one-time password configuration of the authenticated user
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTotpConfiguration(observe?: 'body', reportProgress?: boolean): Observable<TotpConfiguration>;
    public getTotpConfiguration(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TotpConfiguration>>;
    public getTotpConfiguration(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TotpConfiguration>>;
    public getTotpConfiguration(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TotpConfiguration>(`${this.basePath}/totpConfiguration`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replaces current time-based one-time password (TOTP) configuration with a new configuration
     * Replaces existing time-based one-time password configuration of the authenticated user with a new configuration. After creating the new configuration, user must configure her MFA / TOTP device and activate this configuration by supplying codes generated by the configured device.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTotpConfiguration(observe?: 'body', reportProgress?: boolean): Observable<TotpConfiguration>;
    public updateTotpConfiguration(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TotpConfiguration>>;
    public updateTotpConfiguration(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TotpConfiguration>>;
    public updateTotpConfiguration(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<TotpConfiguration>(`${this.basePath}/totpConfiguration`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
